import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eb7e5a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "date-card" }
const _hoisted_2 = { class: "date" }
const _hoisted_3 = { class: "month" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.day), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.month), 1)
    ])
  ]))
}